import { useState, useEffect } from 'react';
export function useLocalStorage(storageKey, defaultValue) {
  function getLocalStorage() {
    const item = window.localStorage.getItem(storageKey);
    return item === null ? null : JSON.parse(item);
  }
  const [value, setValue] = useState(() => {
    var _getLocalStorage;
    return (_getLocalStorage = getLocalStorage()) !== null && _getLocalStorage !== void 0 ? _getLocalStorage : defaultValue;
  });
  useEffect(() => {
    function setLocalStorage(val) {
      window.localStorage.setItem(storageKey, JSON.stringify(val));
    }
    setLocalStorage(value);
  }, [storageKey, value]);
  return [value, setValue];
}